import { useMemo } from 'react';
import { useAuth } from '@/contexts/SharedAuthContext';
import { useLandingMe } from './useLandingMe';
import { applyLandingVars, LANDING_VAR_NAMES, type LandingVars } from '../../../../shared/people-landing-vars';

// La función pura vive en shared/people-landing-vars.ts (testeada desde el backend).
export { applyLandingVars, LANDING_VAR_NAMES, type LandingVars };

/** Variables de la persona logueada: getMe (Fase 4) con fallback al nombre del token. */
export function useLandingVars(): LandingVars {
  const { user } = useAuth();
  const { data: me } = useLandingMe();
  return useMemo(() => {
    const nombre = (me?.fullName || user?.name || '').trim();
    return {
      nombre: nombre || undefined,
      primer_nombre: me?.firstName || (nombre ? nombre.split(/\s+/)[0] : undefined),
      team: me?.onboarding?.team || undefined,
      clapbase: me?.onboarding?.clapbase || undefined,
      dia: me?.onboarding && me.onboarding.day > 0 ? me.onboarding.day : undefined,
    };
  }, [user?.name, me]);
}
